import { api } from './api';

// Variant picker options for a product: "All Variants" plus each variant, or none
// when the product only has Shopify's single default variant.
export function variantOptionsFor(variants = []) {
  const hasRealVariants = variants.length > 1 ||
    (variants.length === 1 && variants[0].title && variants[0].title !== 'Default Title');
  if (!hasRealVariants) return [];
  return [
    { value: '', label: 'All Variants' },
    ...variants.map(v => ({ value: v.id, label: v.title || v.displayName || 'Default' }))
  ];
}

// Every variant of a product from the product search. Search results only carry a
// product's first few variants, so the rest are fetched when there are more.
export async function loadAllVariants(product) {
  if (!product.hasMoreVariants) return product.variants || [];
  const response = await api.get(`/products/variants/${encodeURIComponent(product.id)}`);
  return response.data;
}
